// Enhance Follow Us section with proper aria-labels and structure
document.addEventListener('DOMContentLoaded', function() {
  // Find the footer social icons section
  const socialIconsSection = document.querySelector('footer .footer-social-icons');
  
  if (socialIconsSection) {
    // Create Follow Us wrapper if it doesn't exist
    if (!socialIconsSection.closest('.follow-us-section')) {
      const followUsWrapper = document.createElement('div');
      followUsWrapper.className = 'follow-us-section';
      
      // Add title
      const title = document.createElement('h3');
      title.className = 'follow-us-title';
      title.textContent = 'FOLLOW US';
      
      // Wrap the social icons
      socialIconsSection.parentNode.insertBefore(followUsWrapper, socialIconsSection);
      followUsWrapper.appendChild(title);
      followUsWrapper.appendChild(socialIconsSection);
    }
    
    // Add proper aria-labels to social links
    const socialLinks = socialIconsSection.querySelectorAll('a');
    socialLinks.forEach(link => {
      // Try to determine the platform from the link URL or existing text
      const href = link.getAttribute('href') || '';
      let platform = '';
      
      if (href.includes('facebook')) {
        platform = 'Facebook';
      } else if (href.includes('instagram')) {
        platform = 'Instagram';
      } else if (href.includes('youtube')) {
        platform = 'YouTube';
      } else if (href.includes('twitter') || href.includes('x.com')) {
        platform = 'Twitter';
      } else if (href.includes('tiktok')) {
        platform = 'TikTok';
      } else if (href.includes('pinterest')) {
        platform = 'Pinterest';
      } else if (href.includes('linkedin')) {
        platform = 'LinkedIn';
      }
      
      if (platform) {
        link.setAttribute('aria-label', platform);
      }
    });
  }
  
  // If using the premium footer section
  const premiumFooter = document.querySelector('.footer-premium');
  if (premiumFooter) {
    const socialSection = premiumFooter.querySelector('.footer-premium__social');
    if (socialSection && !socialSection.closest('.follow-us-section')) {
      const followUsWrapper = document.createElement('div');
      followUsWrapper.className = 'follow-us-section';
      
      const title = document.createElement('h3');
      title.className = 'follow-us-title';
      title.textContent = 'FOLLOW US';
      
      socialSection.parentNode.insertBefore(followUsWrapper, socialSection);
      followUsWrapper.appendChild(title);
      followUsWrapper.appendChild(socialSection);
    }
  }
});